import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';
import { MapPinnedIcon } from 'lucide-react';
import { PageShell, EmptyState, Button } from '@noor/ui';

/**
 * Branded 404 shown for any unmatched path (the router's
 * `defaultNotFoundComponent`). It renders inside the app shell's content area,
 * so the header/nav stay put and the user can navigate back to the dashboard.
 */
export function NotFound() {
  const { t } = useTranslation('common');

  return (
    <PageShell className="flex items-center justify-center bg-muted">
      <EmptyState
        icon={MapPinnedIcon}
        title={t('notFound.title')}
        description={t('notFound.description')}
        action={
          <Button asChild variant="outline">
            <Link to="/eats">{t('notFound.home')}</Link>
          </Button>
        }
      />
    </PageShell>
  );
}
